// Placeholder pages that exist so navigation works end-to-end. Built in later rounds (Admin console: AdminPage.tsx, Part 3).
// Settings has a × (top right) back to the page you came from (comment #25, 03/Oct/26).
import { PageHeader } from "../ui/kit";
import { goBack, type Route } from "../router";
import { Icon } from "../ui/icons";

const CloseX = ({ route }: { route: Route }) =>
  <button className="btn icon close-x" aria-label="Close" title="Close — back to the last page (Esc)" onClick={() => goBack(route)}><Icon name="close" /></button>;

export function SettingsPage() {
  return <PageHeader crumb="Settings" title="Settings" actions={<CloseX route={{ name: "settings" }} />}
    sub="Personal settings (profile, password, notifications) — coming in a later part." />;
}

export function NotFoundPage() {
  return <PageHeader crumb="BuildNexx" title="Page not found" sub="The link may be out of date, or you do not have access." />;
}
